import { Store } from '@ngrx/store';
import { AuthSevices } from './../../../../../../../libs/api/src/lib/auth.service';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Logout } from '../../../state/actions';

@Component({
  selector: 'fitness-force-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: []
})
export class LogoutComponent implements OnInit {

  constructor(private authService: AuthSevices, private store: Store) { }

  ngOnInit(): void {
    this.componentInit()
  }
  componentInit() {
    this.store.dispatch(new Logout());
  }
}